import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { object, array, bool, number } from "prop-types";
import { trackScoreRangeSelected } from "utils/trackingFunctions";
import RawScoreDistributionGraph from "components/DynamicScoreReportScales/RawScoreDistributionGraph";
import ScoreRangeDropdown from "../../ScoreRangeDropdown";
import {
  getResultsDetailsText,
  getBellCurveExplanation,
  getInvalidTextElement,
} from "./rawScoreTestReportHelpers";

const RawScoreTestReport = ({
  candidateInfo,
  criteriaScoreRanges,
  customScoreRanges,
  initialScoreRange,
  isInvalidTest,
  scoreRangeOptions,
  SelectedScoreRangeSection,
  SubcategoryScoreColumns,
  testId,
  testInfo,
  testScores,
}) => {
  const [scoreRangeToDisplay, setScoreRangeToDisplay] = useState(null);

  useEffect(() => {
    setScoreRangeToDisplay(initialScoreRange);
  }, [initialScoreRange]);

  const handleScoreRangeSelection = (rangeKey) => {
    const testName = testInfo ? testInfo.get("testAbbreviation") : "";
    trackScoreRangeSelected(testName);

    if (rangeKey === "0") {
      setScoreRangeToDisplay(null);
    } else {
      const newScoreRange =
        scoreRangeOptions &&
        scoreRangeOptions.has(rangeKey) &&
        scoreRangeOptions.get(rangeKey);

      if (newScoreRange) {
        const rangeName = newScoreRange.get("name") || rangeKey;
        const rangeLimits = newScoreRange.get("range").split(",");
        setScoreRangeToDisplay({
          rangeName,
          rangeMin: Number(rangeLimits[0]),
          rangeMax: Number(rangeLimits[1]),
        });
      }
    }
  };

  const rawScore = testScores ? testScores.get("rawScore") : null;
  const percentile = testScores ? testScores.get("percentile") : null;

  return (
    <>
      <Row className="mx-1 py-3">
        <Col>
          <Row className="d-flex justify-content-between">
            <Col className="pl-0">
              <h2 className="score-detail-section-heading">Raw Score</h2>
            </Col>
            <Col lg={8}>
              <Row className="d-flex justify-content-end mb-4">
                <Col className="pr-0">
                  <p className="mt-2 mb-0 text-right">
                    Compare to Score Range:
                  </p>
                </Col>
                <Col className="px-0">
                  <ScoreRangeDropdown
                    criteriaScoreRanges={criteriaScoreRanges}
                    customScoreRanges={customScoreRanges}
                    handleScoreRangeSelection={handleScoreRangeSelection}
                    scoreRangeName={
                      scoreRangeToDisplay && scoreRangeToDisplay.rangeName
                    }
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <RawScoreDistributionGraph
              testId={testId}
              rawScore={rawScore}
              scoreRangeToDisplay={scoreRangeToDisplay}
            />
          </Row>
          {SelectedScoreRangeSection && <hr className="divider" />}
          {SelectedScoreRangeSection}
        </Col>
      </Row>
      <Row className="score-report-row">
        <Col>
          <Row>
            <h3 className="score-detail-section-heading">Results Details</h3>
          </Row>
          {isInvalidTest ? getInvalidTextElement(testId) : null}
          {getResultsDetailsText(candidateInfo, rawScore, percentile)}
        </Col>
        {SubcategoryScoreColumns.length !== 0 ? (
          <Row className="ml-3">{SubcategoryScoreColumns}</Row>
        ) : (
          <Row className="score-report-row">
            <Col>{getBellCurveExplanation()}</Col>
          </Row>
        )}
      </Row>
    </>
  );
};

RawScoreTestReport.propTypes = {
  candidateInfo: object,
  criteriaScoreRanges: object,
  customScoreRanges: object,
  initialScoreRange: object,
  isInvalidTest: bool,
  scoreRangeOptions: object,
  SelectedScoreRangeSection: object,
  SubcategoryScoreColumns: array,
  testId: number,
  testInfo: object,
  testScores: object,
};

export default RawScoreTestReport;
